import React, { forwardRef } from 'react';
import { InfoCardWrapper, InfoCardContent } from './view';

interface Props {
    children?: React.ReactNode;
}

export const InfoCard = forwardRef<HTMLDivElement, Props>(({ children }, ref) => (
    <InfoCardWrapper
        ref={ref}
        onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()}
    >
        <InfoCardContent
            variant="body3"
            colorVariant="base"
        >
            {children}
        </InfoCardContent>
    </InfoCardWrapper>
));
InfoCard.displayName = 'InfoCard';
